/* Ready-made bag embroidery: add AED 30 with a pair id, then keep cart lines in sync.
   If the fee cannot be added, the personalised bag is removed so it cannot check out unpaid. */
(function () {
  var PAIR = '_lc_pair';
  var ADDON = '_lc_embroidery_addon';
  var FALLBACK_VARIANT = 63395564552332;
  var UNPAID_ERROR = {
    status: 422,
    message: 'Cart Error',
    description: 'Embroidery could not be added just now. Please try again.',
  };
  var lock = false;
  var queued = false;
  var timer = null;
  var checkoutPass = false;
  var checkoutHold = false;
  var failEmbroidery = false;

  function pairId() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'lc' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function routes() {
    return window.routes || {};
  }

  function addUrl() {
    return routes().cart_add_url || '/cart/add.js';
  }

  function changeUrl() {
    return routes().cart_change_url || '/cart/change.js';
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/javascript' };
  }

  function props(item) {
    return (item && item.properties) || {};
  }

  function isAddon(item) {
    var value = props(item)[ADDON];
    return value === '1' || value === 1 || value === true;
  }

  function isNamedBag(item) {
    if (!item || isAddon(item)) return false;
    return !!(props(item).Name && String(props(item).Name).trim());
  }

  function isErrorResponse(response) {
    if (!response) return true;
    var status = Number(response.status);
    return status >= 400;
  }

  function unpaidError() {
    return { status: UNPAID_ERROR.status, message: UNPAID_ERROR.message, description: UNPAID_ERROR.description };
  }

  function itemsHaveAddon(items) {
    return (items || []).some(function (item) {
      return item && item.properties && (item.properties[ADDON] === '1' || item.properties[ADDON] === 1);
    });
  }

  function setChecking(on) {
    if (!document.body) return;
    document.body.classList.toggle('lc-embroidery-checking', !!on);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      return response.json();
    });
  }

  function changeLineRaw(key, quantity, extra) {
    var payload = { id: key, quantity: quantity };
    if (extra && extra.sections) payload.sections = extra.sections;
    if (extra && extra.sections_url) payload.sections_url = extra.sections_url;
    return fetch(changeUrl(), {
      method: 'POST',
      headers: jsonHeaders(),
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json();
    });
  }

  function changeLine(key, quantity, extra) {
    if (!failEmbroidery || quantity === 0) return changeLineRaw(key, quantity, extra);
    return getCart().then(function (cart) {
      var item = ((cart && cart.items) || []).find(function (line) {
        return line.key === key;
      });
      if (item && isAddon(item)) return unpaidError();
      return changeLineRaw(key, quantity, extra);
    });
  }

  function addItems(items, extra) {
    if (failEmbroidery && itemsHaveAddon(items)) return Promise.resolve(unpaidError());
    var payload = { items: items };
    if (extra) {
      if (extra.sections) payload.sections = extra.sections;
      if (extra.sections_url) payload.sections_url = extra.sections_url;
    }
    return fetch(addUrl(), {
      method: 'POST',
      headers: jsonHeaders(),
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json();
    });
  }

  function cartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function sectionsPayload(cart) {
    var extra = {};
    if (cart && typeof cart.getSectionsToRender === 'function') {
      extra.sections = cart.getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      extra.sections_url = window.location.pathname;
    }
    return extra;
  }

  function publishCart(response, source, variantId) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source || 'lc-embroidery',
        productVariantId: variantId ? String(variantId) : undefined,
        cartData: response,
      });
    }
    var cart = cartUi();
    if (!cart) return;
    if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    if (response && response.sections && typeof cart.renderContents === 'function') {
      cart.renderContents(response);
    } else if (typeof cart.open === 'function') {
      cart.open();
    }
  }

  function matchEmbIndex(bag, embs, used) {
    var bagProps = props(bag);
    var i;
    if (bagProps[PAIR]) {
      for (i = 0; i < embs.length; i++) {
        if (!used[i] && props(embs[i])[PAIR] === bagProps[PAIR]) return i;
      }
    }
    var name = String(bagProps.Name || '').trim();
    var colour = String(bagProps['Embroidery colour'] || '').trim();
    var title = bag.product_title || '';
    for (i = 0; i < embs.length; i++) {
      if (used[i]) continue;
      var embroideryProps = props(embs[i]);
      if (bagProps[PAIR] && embroideryProps[PAIR] && embroideryProps[PAIR] !== bagProps[PAIR]) continue;
      if (String(embroideryProps.Name || '').trim() !== name) continue;
      if (String(embroideryProps['Embroidery colour'] || '').trim() !== colour) continue;
      if (embroideryProps.For && title && embroideryProps.For !== title) continue;
      return i;
    }
    return -1;
  }

  function embroideryProperties(bag, pair) {
    var bagProps = props(bag);
    var out = {
      _lc_embroidery_addon: '1',
      _lc_pair: pair,
      For: bag.product_title || '',
      Name: String(bagProps.Name || '').trim(),
      'Embroidery colour': String(bagProps['Embroidery colour'] || '').trim(),
    };
    if (bagProps.Print) out.Print = bagProps.Print;
    if (bagProps['Custom fabric']) out.Print = out.Print || bagProps['Custom fabric'];
    return out;
  }

  function findMatchingBag(cart, variantId, bagProperties) {
    var items = (cart && cart.items) || [];
    return items.find(function (item) {
      if (isAddon(item)) return false;
      if (Number(item.id) !== Number(variantId)) return false;
      var itemProps = props(item);
      return (
        String(itemProps.Name || '') === String(bagProperties.Name || '') &&
        String(itemProps['Embroidery colour'] || '') === String(bagProperties['Embroidery colour'] || '') &&
        String(itemProps['Custom fabric'] || '') === String(bagProperties['Custom fabric'] || '')
      );
    });
  }

  function findAddonForPair(cart, pair) {
    if (!pair) return null;
    return ((cart && cart.items) || []).find(function (item) {
      return isAddon(item) && props(item)[PAIR] === pair;
    });
  }

  function findBagForPair(cart, pair) {
    if (!pair) return null;
    return ((cart && cart.items) || []).find(function (item) {
      return isNamedBag(item) && props(item)[PAIR] === pair;
    });
  }

  function hasUnpaidNamedBags(cart) {
    if (!cart) return true;
    var bags = (cart.items || []).filter(isNamedBag);
    var embs = (cart.items || []).filter(isAddon);
    var used = embs.map(function () {
      return false;
    });
    var i;
    var index;
    for (i = 0; i < bags.length; i++) {
      index = matchEmbIndex(bags[i], embs, used);
      if (index === -1) return true;
      used[index] = true;
      if (embs[index].quantity !== bags[i].quantity) return true;
    }
    return false;
  }

  function removeLine(item, extra) {
    if (!item) return Promise.resolve(null);
    return changeLineRaw(item.key, 0, extra);
  }

  function restoreEmbroidery(bag, extra) {
    var pair = props(bag)[PAIR] || pairId();
    return addItems(
      [
        {
          id: FALLBACK_VARIANT,
          quantity: bag.quantity,
          properties: embroideryProperties(bag, pair),
        },
      ],
      extra
    );
  }

  function reconcile() {
    if (lock) {
      queued = true;
      return Promise.resolve();
    }
    lock = true;
    return getCart()
      .then(function sync(cart) {
        if (hasUnpaidNamedBags(cart)) setChecking(true);
        var extra = sectionsPayload(cartUi());
        var bags = (cart.items || []).filter(isNamedBag);
        var embs = (cart.items || []).filter(isAddon);
        var used = embs.map(function () {
          return false;
        });
        var i;
        var index;
        var bag;
        for (i = 0; i < bags.length; i++) {
          bag = bags[i];
          index = matchEmbIndex(bag, embs, used);
          if (index === -1) {
            return restoreEmbroidery(bag, extra).then(function (response) {
              if (isErrorResponse(response)) {
                return removeLine(bag, extra).then(function (rolled) {
                  publishCart(rolled || response, 'lc-embroidery-sync');
                  return getCart().then(sync);
                });
              }
              publishCart(response, 'lc-embroidery-sync');
              return getCart().then(sync);
            });
          }
          used[index] = true;
          if (embs[index].quantity === bag.quantity) continue;
          if (embs[index].quantity < bag.quantity) {
            return changeLine(embs[index].key, bag.quantity).then(function (response) {
              if (isErrorResponse(response)) {
                return changeLineRaw(bag.key, embs[index].quantity, extra).then(function (rolled) {
                  publishCart(rolled || response, 'lc-embroidery-sync');
                  return getCart().then(sync);
                });
              }
              publishCart(response, 'lc-embroidery-sync');
              return getCart().then(sync);
            });
          }
          return changeLineRaw(embs[index].key, bag.quantity, extra).then(function (response) {
            publishCart(response, 'lc-embroidery-sync');
            return getCart().then(sync);
          });
        }
        for (i = 0; i < embs.length; i++) {
          if (used[i]) continue;
          return changeLineRaw(embs[i].key, 0, extra).then(function (response) {
            publishCart(response, 'lc-embroidery-sync');
            return getCart().then(sync);
          });
        }
        return cart;
      })
      .catch(function () {
        return getCart().catch(function () {
          return null;
        });
      })
      .then(function (result) {
        lock = false;
        if (queued) {
          queued = false;
          return reconcile();
        }
        setChecking(false);
        return result;
      });
  }

  function scheduleReconcile() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      reconcile();
    }, 180);
  }

  function settlePair(pair, response, extra) {
    function failAndRollback() {
      return getCart().then(function (cart) {
        var bag = findBagForPair(cart, pair);
        var addon = findAddonForPair(cart, pair);
        var chain = Promise.resolve(null);
        if (bag) chain = chain.then(function () {
          return removeLine(bag, extra);
        });
        if (addon) {
          chain = chain.then(function (rolled) {
            return removeLine(addon, extra).then(function (next) {
              return next || rolled;
            });
          });
        }
        return chain.then(function (rolled) {
          if (rolled) publishCart(rolled, 'lc-embroidery-sync');
          return unpaidError();
        });
      });
    }

    if (isErrorResponse(response)) return failAndRollback();

    return getCart().then(function (cart) {
      var bag = findBagForPair(cart, pair);
      var addon = findAddonForPair(cart, pair);
      if (bag && addon && bag.quantity === addon.quantity) return response;
      if (bag && !addon) {
        return restoreEmbroidery(bag, extra).then(function (retry) {
          if (isErrorResponse(retry)) return failAndRollback();
          return getCart().then(function (nextCart) {
            var nextBag = findBagForPair(nextCart, pair);
            var nextAddon = findAddonForPair(nextCart, pair);
            if (nextBag && nextAddon && nextBag.quantity === nextAddon.quantity) return retry;
            return failAndRollback();
          });
        });
      }
      if (bag && addon && bag.quantity > addon.quantity) {
        return changeLine(addon.key, bag.quantity).then(function (retry) {
          if (isErrorResponse(retry)) {
            return changeLineRaw(bag.key, addon.quantity, extra).then(function () {
              return unpaidError();
            });
          }
          return retry;
        });
      }
      if (!bag && addon) {
        return removeLine(addon, extra).then(function () {
          return isErrorResponse(response) ? response : unpaidError();
        });
      }
      if (!bag && !addon && isErrorResponse(response)) return response;
      if (!bag && !addon) return response;
      return response;
    });
  }

  function addPersonalisedPair(bagItem, embroideryItem, extra) {
    var bagProperties = bagItem.properties || {};
    return getCart().then(function (cartState) {
      var existing = findMatchingBag(cartState, bagItem.id, bagProperties);
      var existingPair = existing && props(existing)[PAIR];
      if (existing && existingPair) {
        var addon = findAddonForPair(cartState, existingPair);
        var prevQty = existing.quantity;
        var nextQty = prevQty + (Number(bagItem.quantity) || 1);
        var embProps = Object.assign({}, embroideryItem.properties || {}, {
          _lc_embroidery_addon: '1',
          _lc_pair: existingPair,
        });
        var embFirst = addon
          ? changeLine(addon.key, nextQty)
          : addItems(
              [
                {
                  id: embroideryItem.id,
                  quantity: nextQty,
                  properties: embProps,
                },
              ],
              extra
            );
        return embFirst.then(function (embResponse) {
          if (isErrorResponse(embResponse)) return unpaidError();
          return getCart().then(function (midCart) {
            var midAddon = findAddonForPair(midCart, existingPair);
            return changeLineRaw(existing.key, nextQty, extra).then(function (bagResponse) {
              if (isErrorResponse(bagResponse)) {
                if (!midAddon) return unpaidError();
                return changeLineRaw(midAddon.key, prevQty, extra).then(function () {
                  return unpaidError();
                });
              }
              return settlePair(existingPair, bagResponse, extra);
            });
          });
        });
      }

      var pair = pairId();
      bagProperties[PAIR] = pair;
      bagItem.properties = bagProperties;
      embroideryItem.properties = Object.assign({}, embroideryItem.properties || {}, {
        _lc_embroidery_addon: '1',
        _lc_pair: pair,
      });
      return addItems(
        [
          { id: bagItem.id, quantity: bagItem.quantity || 1, properties: bagProperties },
          {
            id: embroideryItem.id,
            quantity: embroideryItem.quantity || bagItem.quantity || 1,
            properties: embroideryItem.properties,
          },
        ],
        extra
      ).then(function (response) {
        return settlePair(pair, response, extra);
      });
    });
  }

  function yoursForForm(form) {
    var nodes = document.querySelectorAll('[data-lc-yours]');
    var i;
    var wrap;
    var formId = form && form.id;
    for (i = 0; i < nodes.length; i++) {
      wrap = nodes[i];
      if (formId && wrap.querySelector('[form="' + formId + '"]')) return wrap;
      if (wrap.closest('form') === form) return wrap;
    }
    return nodes[0] || null;
  }

  function setPersonalising(on) {
    document.body.classList.toggle('lc-personalising', !!on);
  }

  function showYoursError(wrap, message) {
    var box = wrap && wrap.querySelector('[data-lc-yours-error]');
    if (!box) return;
    if (message) {
      box.hidden = false;
      box.textContent = message;
    } else {
      box.hidden = true;
      box.textContent = '';
    }
  }

  function bindYours(wrap) {
    if (!wrap || wrap.getAttribute('data-lc-yours-bound') === '1') return;
    wrap.setAttribute('data-lc-yours-bound', '1');
    var box = wrap.querySelector('[data-lc-personalise-toggle]');
    var fields = wrap.querySelector('[data-lc-personalise-fields]');
    var name = wrap.querySelector('[data-lc-embroidery-name]');
    var charge = wrap.querySelector('[data-lc-embroidery-charge]');
    var colour = wrap.querySelector('[data-lc-embroidery-colour]');
    if (!box || !fields || !name || !charge) return;

    var sync = function () {
      var on = box.checked;
      fields.hidden = !on;
      name.disabled = !on;
      charge.disabled = !on;
      if (colour) colour.disabled = !on;
      wrap.querySelectorAll('[data-lc-colour]').forEach(function (button) {
        button.disabled = !on;
      });
      charge.value = on && name.value.trim() && (!colour || colour.value) ? 'AED 30' : '';
      setPersonalising(on);
      if (!on) showYoursError(wrap, '');
    };

    box.addEventListener('change', sync);
    name.addEventListener('input', sync);
    wrap.querySelectorAll('[data-lc-colour]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!box.checked) return;
        var value = button.getAttribute('data-colour-name') || '';
        if (colour) colour.value = value;
        wrap.querySelectorAll('[data-lc-colour]').forEach(function (node) {
          node.setAttribute('aria-pressed', node === button ? 'true' : 'false');
        });
        showYoursError(wrap, '');
        sync();
      });
    });
    sync();
  }

  function bindAllYours() {
    document.querySelectorAll('[data-lc-yours]').forEach(bindYours);
    var anyOn = !!document.querySelector('[data-lc-personalise-toggle]:checked');
    setPersonalising(anyOn);
  }

  function setProductFormLoading(form, on) {
    var productForm = form && form.closest('product-form');
    if (!productForm || !productForm.submitButton) return productForm;
    if (on) {
      productForm.submitButton.setAttribute('aria-disabled', 'true');
      productForm.submitButton.classList.add('loading');
      var spinner = productForm.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      productForm.submitButton.classList.remove('loading');
      var hideSpinner = productForm.querySelector('.loading__spinner');
      if (hideSpinner) hideSpinner.classList.add('hidden');
      if (productForm.submitButton.getAttribute('aria-disabled') === 'true' && !productForm.error) {
        productForm.submitButton.removeAttribute('aria-disabled');
      }
    }
    return productForm;
  }

  function addPersonalised(form, wrap, bagProperties, quantity) {
    var variantInput = form.querySelector('[name="id"]');
    var bagId = variantInput ? Number(variantInput.value) : 0;
    var embroideryVariantId = Number(wrap.getAttribute('data-lc-embroidery-variant') || 0) || FALLBACK_VARIANT;
    var productTitle = wrap.getAttribute('data-lc-product-title') || '';
    var cart = cartUi();
    var extra = sectionsPayload(cart);
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    return addPersonalisedPair(
      { id: bagId, quantity: quantity, properties: bagProperties },
      {
        id: embroideryVariantId,
        quantity: quantity,
        properties: {
          _lc_embroidery_addon: '1',
          For: productTitle,
          Name: bagProperties.Name,
          'Embroidery colour': bagProperties['Embroidery colour'] || '',
        },
      },
      extra
    );
  }

  function isCheckoutTrigger(target) {
    if (!target || !target.closest) return null;
    return (
      target.closest('[name="checkout"]') ||
      target.closest('.shopify-payment-button, [data-shopify="payment-button"]') ||
      target.closest('button[form*="cart"][type="submit"]')
    );
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var wrap = yoursForForm(form);
      if (!wrap) return;
      var box = wrap.querySelector('[data-lc-personalise-toggle]');
      if (!box || !box.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var name = wrap.querySelector('[data-lc-embroidery-name]');
      var colour = wrap.querySelector('[data-lc-embroidery-colour]');
      var nameValue = name && name.value ? name.value.trim() : '';
      var colourValue = colour && colour.value ? colour.value.trim() : '';
      if (!nameValue) {
        showYoursError(wrap, 'Please add a name or initials to embroider.');
        return;
      }
      if (colour && !colourValue) {
        showYoursError(wrap, 'Please choose an embroidery colour.');
        return;
      }

      var productForm = form.closest('product-form');
      if (productForm && productForm.submitButton && productForm.submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      var qtyInput = form.querySelector('[name="quantity"]');
      var quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;
      var bagProperties = { Name: nameValue, Embroidery: 'AED 30' };
      if (colourValue) bagProperties['Embroidery colour'] = colourValue;
      var fabric = form.querySelector('[name="properties[Custom fabric]"]');
      if (fabric && fabric.value) bagProperties['Custom fabric'] = fabric.value;

      showYoursError(wrap, '');
      setProductFormLoading(form, true);
      addPersonalised(form, wrap, bagProperties, quantity)
        .then(function (response) {
          if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
          if (response && response.status) {
            if (productForm && typeof productForm.handleErrorMessage === 'function') {
              productForm.handleErrorMessage(response.description || 'This piece could not be added just now.');
            }
            return;
          }
          if (!cartUi()) {
            window.location = routes().cart_url || '/cart';
            return;
          }
          publishCart(response, 'product-form', form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
        })
        .catch(function () {
          if (productForm && typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage('This piece could not be added just now.');
          }
        })
        .then(function () {
          setProductFormLoading(form, false);
        });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = isCheckoutTrigger(event.target);
      if (!trigger) return;

      var isPayment = trigger.closest && trigger.closest('.shopify-payment-button, [data-shopify="payment-button"]');
      if (document.body.classList.contains('lc-personalising') && isPayment) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var wrap = document.querySelector('[data-lc-yours]');
        showYoursError(wrap, 'Please use Add to cart so embroidery can be included.');
        return;
      }

      var onCart =
        window.location.pathname.indexOf('/cart') === 0 ||
        !!(trigger.closest && trigger.closest('cart-drawer, cart-notification, #main-cart-footer, .cart__footer'));
      if (!onCart) return;

      if (checkoutPass) return;
      if (checkoutHold) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutHold = true;
      setChecking(true);
      reconcile()
        .then(function (cart) {
          checkoutHold = false;
          if (hasUnpaidNamedBags(cart)) {
            setChecking(false);
            return;
          }
          checkoutPass = true;
          setChecking(false);
          if (typeof trigger.click === 'function') trigger.click();
          setTimeout(function () {
            checkoutPass = false;
          }, 1500);
        })
        .catch(function () {
          checkoutHold = false;
          setChecking(false);
        });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    bindAllYours();
    scheduleReconcile();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'lc-embroidery-sync') return;
      scheduleReconcile();
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.source === 'lc-embroidery-sync') return;
          scheduleReconcile();
        });
      }
    });
  }

  window.LCEmbroidery = {
    pairId: pairId,
    PAIR: PAIR,
    ADDON: ADDON,
    getCart: getCart,
    changeLine: changeLine,
    addItems: addItems,
    findMatchingBag: findMatchingBag,
    findAddonForPair: findAddonForPair,
    reconcile: reconcile,
    sectionsPayload: sectionsPayload,
    publishCart: publishCart,
    addPersonalisedPair: addPersonalisedPair,
    hasUnpaidNamedBags: hasUnpaidNamedBags,
    setFailEmbroidery: function (on) {
      failEmbroidery = !!on;
    },
  };
})();
